import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription as RxJsSubscription } from 'rxjs';
import { ModuleQCMSearchParams } from '../../module-qcm-search-params';
import { ModuleQCM } from '../../module-qcm';
import { Helpers } from '@app/shared';
@Component({
	selector: 'hpf-module-qcm-list',
	templateUrl: './module-qcm-list.component.html',
	styleUrls: [],
})
export class ModuleQCMListComponent implements OnInit, OnDestroy {
	/** The filters */
	searchParams = new ModuleQCMSearchParams(this.route.snapshot.queryParams);
	/** The search params subscription */
	private paramsSubscription: RxJsSubscription;
	/** Used to open or close filter drawer */
	filtersDrawer = false;
	/** Constructor */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private location: Location
	) {}
	/** Init */
	ngOnInit() {
		// Update query string when params change
		this.paramsSubscription = this.searchParams.subscribe(() => {
			this.location.replaceState(
				'/module-qcm',
				Helpers.toQueryString(this.searchParams.toObject())
			);
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.paramsSubscription.unsubscribe();
	}
	/** Called when the user select a row in the table */
	onSelect(item: ModuleQCM) {
		this.router.navigateByUrl(`/module-qcm/${item.getId()}`);
	}
	/** Called when the user click on create */
	onCreate() {
		this.router.navigate(['/module-qcm/create']);
	}
}
